import angular from 'angular'
import pitchCardComponent from './pitchCard.component'

export default angular
  .module('ellipsis.pitchCard', [])
  .component('pitchCard', pitchCardComponent)
